"use client";
import React, { useState, useRef } from "react";

const FAQItemRow = ({ faq, isOpen, onToggle }: { faq: any; isOpen: boolean; onToggle: () => void }) => {
  const contentRef = useRef<HTMLDivElement>(null);

  return (
    <div className="py-5 md:py-6">
      <h3 className="m-0 p-0 text-inherit font-normal">
        <button
          type="button"
          onClick={onToggle}
          className="w-full text-left flex justify-between items-center gap-4 bg-transparent border-none cursor-pointer group select-none"
          aria-expanded={isOpen}
        >
          <span className={`text-md md:text-lg font-bold transition-colors duration-200 flex-1 leading-snug ${isOpen ? 'text-indigo-600' : 'text-slate-800 group-hover:text-indigo-600'
            }`}>
            {faq.question}
          </span>

          <span aria-hidden="true" className={`text-3xl font-light transition-transform duration-300 shrink-0 ${isOpen ? 'text-indigo-600 rotate-45' : 'text-slate-400 group-hover:text-indigo-600'
            }`}>
            +
          </span>
        </button>
      </h3>

      <div
        ref={contentRef}
        style={{
          maxHeight: isOpen ? `${contentRef.current?.scrollHeight || 500}px` : '0px',
          opacity: isOpen ? 1 : 0
        }}
        className="overflow-hidden transition-all duration-300 ease-in-out"
      >
        <div
          className="pt-4 border-t border-slate-100 text-slate-500 text-sm md:text-base leading-relaxed whitespace-pre-line"
          dangerouslySetInnerHTML={{ __html: faq.answer }}
        />
      </div>
    </div>
  );
};

const FAQList = ({ faqs }: { faqs: any[] }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [showAll, setShowAll] = useState(false);

  const INITIAL_LIMIT = 5;
  const displayedFaqs = showAll ? faqs : faqs.slice(0, INITIAL_LIMIT);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <div className="divide-y divide-slate-200 max-w-4xl mx-auto border-t border-b border-slate-200">
        {displayedFaqs.map((faq: any, index: number) => (
          <FAQItemRow
            key={faq.id || index}
            faq={faq}
            isOpen={openIndex === index}
            onToggle={() => toggleFAQ(index)}
          />
        ))}
      </div>

      {faqs.length > INITIAL_LIMIT && (
        <div className="mt-10 text-center">
          <button
            type="button"
            onClick={() => setShowAll(!showAll)}
            className="inline-flex items-center gap-2 px-8 py-3 text-sm font-bold text-white bg-slate-900 rounded-full hover:bg-indigo-600 transition-all duration-300 shadow-lg hover:shadow-indigo-200 hover:-translate-y-0.5"
          >
            <span>{showAll ? "Show Less" : `View All ${faqs.length} Questions`}</span>
            <svg
              className={`w-4 h-4 transition-transform duration-300 ${showAll ? "rotate-180" : ""}`}
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
        </div>
      )}
    </>
  );
};

export default FAQList;